class GoogleCalendarUtils {
  calendarWarningDismissed = false;

  constructor(Authentication, $state, $window, $interval) {
    'ngInject';

    Object.assign(this, { Authentication, $state, $window, $interval });
    this.authWindow = null;
  }

  getGoogleCalendarUrl() {
    return this.Authentication.sendRequest({ path: 'integrations/google_calendar' });
  }

  focusWindow() {
    this.authWindow?.focus();
  }

  async authenticateGoogleCalendar(code) {
    await this.Authentication.sendRequest({
      method: 'post',
      path: 'integrations/google_calendar',
      payload: { code },
    });
    this.Authentication.googleCalendarExpired = false;
  }

  openGoogleCalendarModal() {
    this._setAuthWindow();

    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      const intervalPromise = this._setCallbacks(resolve, reject);

      try {
        const {
          data: { redirectUrl },
        } = await this.getGoogleCalendarUrl();
        if (redirectUrl) {
          this.authWindow.location.href = redirectUrl;
        }
      } catch (error) {
        reject();
        this.$interval.cancel(intervalPromise);
        this.authWindow.close();
        throw error;
      }
    });
  }

  _setAuthWindow() {
    if (!this.authWindow || this.authWindow.closed) {
      this.authWindow = this.$window.open('about:blank', '_blank', 'width=600, height=600');
    } else {
      this.authWindow.focus();
    }
  }

  _setCallbacks(resolve, reject) {
    const intervalPromise = this.$interval(() => {
      if (this.authWindow.closed) {
        reject();
        this.$interval.cancel(intervalPromise);
      }
    }, 500);

    this.$window.resolveGoogleCalendarPromise = (...args) => {
      this.$interval.cancel(intervalPromise);
      resolve(...args);
    };

    return intervalPromise;
  }
}

export default GoogleCalendarUtils;
